import { render, staticRenderFns } from "./files.vue?vue&type=template&id=3965436f&scoped=true"
import script from "./files.vue?vue&type=script&lang=js"
export * from "./files.vue?vue&type=script&lang=js"
import style0 from "@/styles/pc.css?vue&type=style&index=0&id=3965436f&prod&scoped=true&lang=css&external"
import style1 from "./files.vue?vue&type=style&index=1&id=3965436f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3965436f",
  null
  
)

export default component.exports